module.exports = __webpack_public_path__ + "img/4Y5.a57fa9f7.png";